module.exports = __webpack_public_path__ + "static/IBMPlexMono-Bold-82c4f1458bb607fa1f5deda7ce14c087.woff";